<template>
	<v-row class="pa-5" v-if="exercise">
		<v-col cols="12">
			<h2>Priorities</h2>
		</v-col>
		<v-col cols="10">
			<v-row>
				<v-col cols="6">
					<v-card light color="light-green accent-2">
						<v-card-text>
							<unit-area-items
								v-model="exercise.doc.matrix.q1"
								name="matrix.q1"
								title="Quick Wins"
								subtitle="High impact, Low effort"
							></unit-area-items>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="6">
					<v-card color="orange lighten-1">
						<v-card-text>
							<unit-area-items
								v-model="exercise.doc.matrix.q2"
								name="matrix.q2"
								title="Phase 2 Projects"
								subtitle="High impact, High effort"
							></unit-area-items> </v-card-text
					></v-card>
				</v-col>
				<v-col cols="6">
					<v-card light color="yellow lighten-1">
						<v-card-text>
							<unit-area-items
								v-model="exercise.doc.matrix.q3"
								name="matrix.q3"
								title="Phase 1 Tasks"
								subtitle="Low impact, Low effort"
							></unit-area-items> </v-card-text
					></v-card>
				</v-col>
				<v-col cols="6">
					<v-card light color="deep-orange lighten-1">
						<v-card-text>
							<unit-area-items
								v-model="exercise.doc.matrix.q4"
								name="matrix.q4"
								title="Nice to have"
								subtitle="Low impact, High effort"
							></unit-area-items> </v-card-text
					></v-card>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require('@/firebaseConfig.js');
import { mapState } from 'vuex';
import { UnitAreaItems } from '@/components/units';

export default {
	name: 'ResultsUserPriority',
	data() {
		return {
			doc: null,
			exercise: null,
			dialog: false,
		};
	},
	props: {
		uid: String,
		id: String,
	},
	components: {
		UnitAreaItems,
	},
	mounted() {
		this.getExercise();
	},
	computed: {
		...mapState([
			'userProfile',
			'currentUser',
			'currentProject',
			'currentProjectModel',
		]),
	},
	methods: {
		getExercise() {
			console.log('get exercise');
			let ref = fb.priorityExCollection
				.where('pid', '==', this.id)
				.where('uid', '==', this.uid);
			ref.onSnapshot((querySnapshot) => {
				let items = [];
				querySnapshot.forEach((docs) => {
					let doc = docs.data();
					items.push(doc);
				});
				this.exercise = items[0];
			});
		},
	},
};
</script>
